export type GymReservation = {
  outlet: string
  outletName: string
  phone: string
  email: string
}

export const initialReservation: GymReservation = {
  outlet: '',
  outletName: '',
  phone: '',
  email: '',
}
